import titleAndDescription from './TitleAndDescription';

export default [titleAndDescription];
